import { serverErrorMessage } from "../constants/serverMessage";
import { SERVERMODE } from "../constants/serverMode";

const handleServerMode = (
  mode,
  message = null,
  contextData,
  cookies,
  removeCookies,
  navigate
) => {
  switch (mode) {
    case SERVERMODE.REQUEST_BAD: {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(serverErrorMessage(1005));
      break;
    }
    case SERVERMODE.REQUEST_NOT_FOUND || SERVERMODE.REQUEST_FIELD: {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(serverErrorMessage(1002));
      break;
    }
    case SERVERMODE.USER_NOT_FOUND:
    case SERVERMODE.REQUEST_TOKEN_EXPIRE:
    case SERVERMODE.REQUEST_TOKEN_WRONG:
    case SERVERMODE.REQUEST_TOKEN_ERROR: {
      for (const item in cookies) {
        if (item !== "slider") {
          removeCookies(item);
        }
      }
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(serverErrorMessage(1008));
      navigate("/login");
      break;
    }
    default: {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(message || serverErrorMessage(1004));
    }
  }
};

export { handleServerMode };
